import React from 'react';
import { useUserContext } from 'contexts';
import { useIsMobile, useIsIpadMini } from 'hooks/use-size-class';
import { buildClassName } from 'utils/build-class-name';
import styles from '../style.module.scss';
import { headerIds } from 'constants/test-constants';

type HeaderContentProps = {
  renderLogo: () => React.ReactNode;
  renderDesktop: () => React.ReactNode;
  renderMobile: () => React.ReactNode;
  isSearchPanelOpen?: boolean;
  useLightTheme?: boolean;
};

/**
 * HeaderContent Component
 * Uses render props pattern for flexible composition of header sections
 * Handles device-specific rendering logic and crawler support
 */
export const HeaderContent = ({ 
  renderLogo,
  renderDesktop,
  renderMobile,
  isSearchPanelOpen,
  useLightTheme,
}: HeaderContentProps) => {
  const isMobile = useIsMobile();
  const isIpadMini = useIsIpadMini();
  const { isCrawler } = useUserContext();

  const shouldShowMobileView = isMobile && !isIpadMini;
  const shouldShowDesktopView = !isMobile || isIpadMini;

  return (
    <div className={buildClassName(styles.component, useLightTheme && styles['light-theme'])} data-testid={headerIds.header}>
      <div className={buildClassName(styles['layout-container'], isSearchPanelOpen && styles['expanded'])}>
        {renderLogo()}
        
        {shouldShowDesktopView && (
          <div className={styles.navigation}>
            {renderDesktop()}
          </div>
        )}
        
        {(shouldShowMobileView || isCrawler) && renderMobile()}
      </div>
    </div>
  );
}; 